module.exports = __webpack_public_path__ + "static/media/muna_kaki_talking.93868fc0.png";